import React from 'react';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { withStyles } from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import '@material-ui/icons/Event';
import { convertDateToSimpleDate } from '../properties/convert-date-to-simple-date';
const styles = (theme) => ({
    editor: {
        width: '100%',
    },
});
class DatePickerEditor extends React.Component {
    componentDidMount() {
        if (!this.props.value) {
            this.props.setValue(convertDateToSimpleDate(new Date()));
        }
    }
    render() {
        const { classes, value } = this.props;
        return (React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
            React.createElement(DatePicker, { className: classes.editor, allowKeyboardControl: true, label: this.props.propertyOptions.displayName, format: "DD/MM/YYYY", value: value, onChange: (momentDate) => {
                    const newDate = momentDate.toDate();
                    newDate.setHours(0);
                    newDate.setMinutes(0);
                    newDate.setSeconds(0);
                    newDate.setMilliseconds(0);
                    this.props.setValue(newDate);
                }, animateYearScrolling: false, rightArrowIcon: React.createElement(ChevronRight, null), leftArrowIcon: React.createElement(ChevronLeft, null), showTodayButton: true })));
    }
}
export default (options = {}) => withStyles(styles)(DatePickerEditor);
